import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import MajorItem from "./MajorItem";
import SubItem from "./SubItem";

import { AdDatabaseSVG } from "../../../assets/img/AdDatabaseSVG";
import { AdOffericonSVG } from "../../../assets/img/AdOffericonSVG";
import { AdProjecticonSVG } from "../../../assets/img/AdProjecticonSVG";
import { AdTOPSliderSVG } from "../../../assets/img/AdTOPSliderSVG";
import { IconCalendarSVG } from "../../../assets/img/iconCalendarSVG";
import { IconTopicsSVG } from "../../../assets/img/IconTopicsSVG";
import { IconFacilitySVG } from "../../../assets/img/facility/IconFacilitySVG";

type Props = {
  isSideBarOpen: boolean;
};

const AdminMenu: React.FC<Props> = (props) => {
  const { pathname } = useLocation();

  const { isSideBarOpen } = props;

  const [currentMenu, setCurrentMenu] = useState<number>(0);

  const toggleMenu = (i: number) => {
    if (i === currentMenu) {
      setCurrentMenu(0);
    } else {
      setCurrentMenu(i);
    }
  };

  useEffect(() => {
    if (pathname.includes("/admin/member")) {
      setCurrentMenu(1);
    } else if (
      pathname.includes("/admin/database") ||
      pathname.includes("/admin/release")
    ) {
      setCurrentMenu(2);
    } else if (pathname.includes("/admin/offer")) {
      setCurrentMenu(3);
    } else if (pathname.includes("/admin/project")) {
      setCurrentMenu(4);
    } else if (pathname.includes("/admin/event")) {
      setCurrentMenu(5);
    } else if (pathname.includes("admin/topics")) {
      setCurrentMenu(6);
    } else if (pathname.includes("/admin/taxonomy")) {
      setCurrentMenu(7);
    } else if (pathname.includes("/admin/featured")) {
      setCurrentMenu(8);
    } else if (pathname.includes("/admin/news")) {
      setCurrentMenu(9);
    } else if (pathname.includes("/admin/facility")) {
      setCurrentMenu(10);
    } else if (pathname.includes("/admin/game-selection")) {
      setCurrentMenu(11);
    }
  }, []);

  return (
    <>
      <MajorItem
        link="/admin/member"
        icon={<AdDatabaseSVG width={30} height={30} />}
        isOpen={currentMenu == 1 ? true : false}
        header="会員一覧"
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(1)}
      />
      <MajorItem
        header={"データベース"}
        icon={<AdDatabaseSVG width={30} height={30} />}
        isOpen={currentMenu == 2 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(2)}
      >
        <SubItem
          title="データベース一覧"
          link="/admin/database"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="公開申請"
          link="/admin/release"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        header={"オファー一覧"}
        link="/admin/offer"
        icon={<AdOffericonSVG width={30} height={30} />}
        isOpen={currentMenu == 3 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(3)}
      ></MajorItem>
      <MajorItem
        header={"プロジェクト"}
        icon={<AdOffericonSVG width={30} height={30} />}
        isOpen={currentMenu == 4 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(4)}
      >
        <SubItem
          title="プロジェクト一覧"
          link="/admin/project"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="公開申請"
          link="/admin/project/release"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="応募申請"
          link="/admin/project/application"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        header="イベント"
        icon={<IconCalendarSVG width={30} height={30} />}
        isOpen={currentMenu == 5 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(5)}
      >
        <SubItem
          title="イベント一覧"
          link="/admin/event"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="公開申請"
          link="/admin/event/release"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>

      <MajorItem
        header="トピックス"
        icon={<IconTopicsSVG width={30} height={30} />}
        isOpen={currentMenu == 6 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(6)}
      >
        <SubItem
          title="トピックス一覧"
          link="/admin/topics"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="公開申請"
          link="/admin/topics/release"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        header="施設"
        icon={<IconFacilitySVG width={30} height={30} />}
        isOpen={currentMenu == 10 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(10)}
      >
        <SubItem
          title="施設一覧"
          link="/admin/facility"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="施設新規作成"
          link="/admin/facility/create"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="おすすめ施設設定"
          link="/admin/facility/featured"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="公開申請"
          link="/admin/facility/release"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="削除申請"
          link="/admin/facility/delete"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>

      <MajorItem
        header={"タクソノミー"}
        icon={<AdProjecticonSVG width={30} height={30} />}
        isOpen={currentMenu == 7 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(7)}
      >
        <SubItem
          title="タクソノミー一覧"
          link="/admin/taxonomy"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="ゲーム"
          link="/admin/taxonomy/games"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="パーソンタイプ"
          link="/admin/taxonomy/player_types"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="チーム"
          link="/admin/taxonomy/teams"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="プロジェクトタイプ"
          link="/admin/taxonomy/project_type"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="トピックタイプ"
          link="/admin/taxonomy/topic_type"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        icon={<AdDatabaseSVG width={30} height={30} />}
        isOpen={currentMenu == 8 ? true : false}
        header="イチオシ設定"
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(8)}
      >
        <SubItem
          title="プロフィール"
          link="/admin/featured/profile"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="チーム"
          link="/admin/featured/team"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="プロジェクト"
          link="/admin/featured/project"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="ゲーム"
          link="/admin/featured/game"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        link="/admin/news"
        icon={<AdTOPSliderSVG width={30} height={30} />}
        isOpen={currentMenu == 9 ? true : false}
        header="TOPスライダー"
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(9)}
      />
      <MajorItem
        link="/admin/game-selection"
        icon={<AdProjecticonSVG width={30} height={30} />}
        isOpen={currentMenu == 11 ? true : false}
        header="ゲーム項目設定"
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(11)}
      />
    </>
  );
};

export default AdminMenu;
